import { z } from 'zod';

/**
 * RG180, RG181 - oubay c2f3b5a. A Moroccan number: his pattern, his two
 * messages, and his cleaning. He stripped spaces, dashes and dots in the
 * service before testing; here the schema does it, so the form, the API and
 * the stored value agree on `0612345678` for `06 12-34.56 78`.
 */
export const MOROCCAN_PHONE = /^(?:(?:\+|00)212|0)[5-7]\d{8}$/;

export function cleanPhone(raw: string): string {
  return raw.replace(/[\s\-.]/g, '');
}

export const moroccanPhone = z
  .string({ required_error: 'Le numéro de téléphone est obligatoire' })
  .min(1, 'Le numéro de téléphone est obligatoire')
  .transform(cleanPhone)
  .refine((value) => MOROCCAN_PHONE.test(value), {
    message: 'Numéro marocain invalide (ex: 0612345678 ou +212612345678)',
  });
